<template>
  <div class="flex flex-column justify-between relative full-height">
    <div class="col-12">
      <div v-if="itemsInWorkspace.length" class="flex items-center flex-wrap">
        <div class="col-12 offer-card">
          <CartItem v-for="(item, index) in itemsInWorkspace" :key="index" :item="item" :value="priceToShow(item)" :is-cart-recap="isCartRecap" :pro-rata="proRata" />
          <div v-if="isCartRecap" class="invert flex items-center card-bottom flex-wrap mt3">
            <div class="flex-auto col-6">
              <h2 class="h2n m0">Total</h2>
            </div>
            <div v-if="gymlibSale" class="col-6 right-align">
              <h2 :class="['ucpa-CartMember-total m0 ml3']">0.00 €</h2>
            </div>
            <div v-else class="col-6 right-align">
              <h2 :class="['ucpa-CartMember-total m0 ml3', { 'crossed': showPromotion && !containsGymlibCode }]">{{ priceToShow(itemsInWorkspace[0]) > 0 ? `${priceToShow(itemsInWorkspace[0])} €` : 'Offert' }}</h2>
              <h2 v-if="showPromotion && !containsGymlibCode" class="ucpa-CartMember-total m0 ml3">{{ discountPrice > 0 ? `${discountPrice.toFixed(2)} €` : 'Offert' }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CartItem from '@/components/cart/CartItem.vue';

export default {
  name: 'CartCard',
  components: { CartItem },
  props: {
    isCartRecap: {
      type: Boolean,
      default: false
    },
    discountPrice: {
      type: Number,
      default: null
    },
    proRata: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      workspace: this.$store.getters.workspace,
      cart: this.$store.state.cart
    };
  },
  computed: {
    gymlibSale () {
      const cart = this.cart.items.find(item => item.workspace === this.workspace);

      return cart.details.every(detail => detail.gymlibCode) && !cart.details.some(detail => detail.options && detail.options.length);
    },
    containsGymlibCode () {
      const cart = this.cart.items.find(item => item.workspace === this.workspace);
      return cart.details.some(detail => detail.gymlibCode);
    },
    itemsInWorkspace () {
      if (this.cart && this.cart.items) {
        return this.cart.items.filter(i => i.workspace === this.workspace);
      }
      return [];
    },
    isProrataPrix () {
      return this.itemsInWorkspace.some(i => i.details.some(detail => detail.proRataPrice));
    },
    showPromotion () {
      const price = parseFloat(this.priceToShow(this.itemsInWorkspace[0]));
      return this.discountPrice !== price;
    },
    priceInfo () {
      return this.cart.items.find(item => item.workspace === this.workspace).priceInfo;
    },
    totalPriceCart () {
      return this.priceInfo ? this.priceInfo.totalPrice : null;
    },
    value () {
      return this.totalPriceCart;
    }
  },
  methods: {
    totalPriceWithProRata (cartItem) {
      return cartItem.details.reduce((acc, item) => {
        const totalOptions = item.options.reduce((acc2, item2) => {
          acc2 += item2.price;
          return acc2;
        }, 0);
        return acc + totalOptions;
      }, 0);
    },
    priceToShow (item) {
      return this.isProrataPrix ? (this.totalPriceWithProRata(item) / 100).toFixed(2) : this.value;
    }
  }
};
</script>

<style lang="scss">
</style>
